import { render, staticRenderFns } from "./ForumVotes.vue?vue&type=template&id=316ea75c&"
import script from "./ForumVotes.vue?vue&type=script&lang=js&"
export * from "./ForumVotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports